<template>
  <div class="handout">
    <img class="close-handout" src="../assets/tipp/tipp-cross.svg" @click="$router.go(-1)">
    <LanguageSwitch class="lang-switch"></LanguageSwitch>
    <div class="textsheet">
      <h3>{{$t('handout.title')}}</h3>
      <p><span v-html="$t('handout.text')"></span></p>
      <br>
      <a :href="$t('handout.downloadurl')" class="button" style="background-color: #CCCCCC" target="_blank">{{$t('handout.btn')}}</a>
    </div>
  </div>
</template>

<script>

import LanguageSwitch from "@/components/LanguageSwitch";

export default {
  name: "handout",
  components: {
    LanguageSwitch
  },
}
</script>

<style lang="scss" scoped>
.lang-switch {
  position: absolute;
  top: 0;
  right: 10%;
}

.handout {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  padding: 70px;

  @include tablet-down {
    padding: 25px;
  }
}

.close-handout {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 45px;
  cursor: pointer;

  @include tablet-down {
    width: 35px;
    z-index: 5;
  }
}
</style>
